import Phaser from 'phaser';
import RootBehavior from '../root_behaviors/shuffle';

export default class extends Phaser.GameObjects.Group {
  get tail() {
    return this.rootEndSprite;
  }

  get body() {
    return this.rootEndSprite.body;
  }

  get events() {
    return this._events;
  }

  constructor(config) {
    super(config.scene);

    this.controllerEnabled = false;
    this.scene = config.scene;

    this.x = config.x;
    this.y = config.y;
    this.active = false;
    this._verticalVelocity = 10;
    this._horizontalVelocity = 2;

    this.rootEndSprite = null;

    this.lastRootPlacementY = 0;

    this._events = new Phaser.Events.EventEmitter();

    this.rootBehavior = new RootBehavior(this.scene, {
      velocity: {
        x: this._horizontalVelocity,
        y: this._verticalVelocity
      }
    });
  }

  on(eventName, handler, context) {
    this.events.on(eventName, handler, context);
  }

  enableController() {
    this.controllerEnabled = true;
  }

  grow(x, y) {
    console.log("[Root] Begin growing...");

    this.rootEndSprite = this.scene.physics.add.sprite(x, y, 'root', 1);
    this.rootEndSprite.body.setCollideWorldBounds(true).setVelocityY(this._verticalVelocity).setSize(1, 2).setOffset(2, 2);

    this.add(this.rootEndSprite, true);

    this.rootBehavior.startGrow(x, y);

    this.active = true;
    this.controllerEnabled = true;
  }

  stop() {
    this.active = false;
    this.controllerEnabled = false;
    this.rootEndSprite.body.setVelocityX(0);
    this.rootEndSprite.body.setVelocityY(0);
  }

  update(config) {
    let controller = config.controller;
    if (!this.active) {
      return;
    }
    if (!this.rootEndSprite) {
      return;
    }

    this.rootEndSprite.body.setVelocityX(0);
    this.rootEndSprite.angle = 0;
    this.rootEndSprite.setFrame(1);
    if (controller.left.isDown) {
      this.rootEndSprite.body.setVelocityX(-this._horizontalVelocity);
      // this.rootEndSprite.angle = 10;
      this.rootEndSprite.setFrame(2);
    }
    if (controller.right.isDown) {
      this.rootEndSprite.body.setVelocityX(this._horizontalVelocity);
      // this.rootEndSprite.angle = -10;
      this.rootEndSprite.setFrame(3);
    }

    if (this.controllerEnabled) {
      this.rootBehavior.beforeDraw({ controller: controller, rootEnd: this.rootEndSprite });
    }

    if (this.rootBehavior.willDraw()) {
      this.rootBehavior.draw();

      this.events.emit('grow');
    }
  }
}